import NamedDto from 'modules/base/dto/NamedDto';
import AnnotationValueEditDto from './AnnotationValueEditDto';

export default class MeasurementEditDto extends NamedDto {
	constructor() {
		super();
		/** @type {number} */
		this.project = null;
		/** @type {string} */
		this.location = null;
		/** @type {number} */
		this.device = null;
		/** @type {string} */
		this.recordingType = null;
		/** @type {number} */
		this.recordTimeInSec = null;
		/** @type {AnnotationValueEditDto[]} */
		this.annotationValues = [];
	}

	/**
	 * @typedef {Object} _MeasurementEditDtoProps
	 * @property {number} project
	 * @property {string} location
	 * @property {number} device
	 * @property {StringMap} recordingType
	 * @property {number} recordTimeInSec
	 * @property {AnnotationValueEditDto[]} annotationValues
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _MeasurementEditDtoProps} MeasurementEditDtoProps
	 */
	/**
	 *
	 * @param {MeasurementEditDtoProps} props
	 * @returns {MeasurementEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.project = props.project;
		this.location = props.location;
		this.device = props.device;
		this.recordingType = props.recordingType;
		this.recordTimeInSec = props.recordTimeInSec;
		this.annotationValues = Array.isArray(props.annotationValues)
			? props.annotationValues.map(annotationValue => new AnnotationValueEditDto().setup(annotationValue))
			: [];
		return this;
	}
}
